// LoyaltyLion renders the tier comparison table itself, showing a dot for every
// tier that has a given benefit. The "points per £ spent" row has no text option
// in LoyaltyLion, so we relabel its dots with the actual multiplier per tier.
const POINTS_PER_POUND_LABELS = ["1x", "1.5x"];

const relabelPointsPerPoundRow = ($compare) => {
  const rows = $compare.querySelectorAll(".lion-tier-benefits-compare__row");

  rows.forEach((row) => {
    const $label = row.querySelector(
      ".lion-tier-benefits-compare__benefit-text"
    );

    if (!$label || !/points per/i.test($label.textContent)) return;

    const statusCells = row.querySelectorAll(
      ".lion-tier-benefits-compare__benefit-status"
    );

    statusCells.forEach(($cell, index) => {
      const text = POINTS_PER_POUND_LABELS[index];
      if (!text || $cell.textContent.trim() === text) return;

      $cell.textContent = text;
      $cell.classList.add(
        "lion-tier-benefits-compare__benefit-status--relabelled"
      );
    });
  });
};

export const loyaltyLion = () => {
  const $loyaltyLion = document.querySelector(".shopify-section.loyaltylion");

  if ($loyaltyLion) {
    const process = () => {
      const lionElEarnedPoints = $loyaltyLion.querySelector(
        '[data-lion-points="approved"]'
      );
      const originEarnedPoints = $loyaltyLion.querySelector(
        '[data-ref="earnedPoints"]'
      );

      const lionElPendingPoints = $loyaltyLion.querySelector(
        '[data-lion-points="pending"]'
      );

      const originPendingPoints = $loyaltyLion.querySelector(
        '[data-ref="pendingPoints"]'
      );

      if (lionElEarnedPoints && originEarnedPoints) {
        originEarnedPoints.textContent = `You have ${lionElEarnedPoints.textContent} points.`;
      }

      if (lionElPendingPoints && originPendingPoints) {
        originPendingPoints.textContent = `(${lionElPendingPoints.textContent} pending)`;
      }
    };

    const target = document.querySelector("[data-lion-points]");
    const config = { childList: true, attributes: true };

    const observer = new MutationObserver(() => {
      process();
    });

    observer.observe(target, config);
    process();

    const $tierBenefitsCompare = $loyaltyLion.querySelector(
      "[data-lion-tier-benefits-compare]"
    );

    if ($tierBenefitsCompare) {
      const tierBenefitsObserver = new MutationObserver(() => {
        relabelPointsPerPoundRow($tierBenefitsCompare);
      });

      tierBenefitsObserver.observe($tierBenefitsCompare, {
        childList: true,
        subtree: true,
      });
      relabelPointsPerPoundRow($tierBenefitsCompare);
    }
  }
};

export default loyaltyLion;
